export function useGetBrowsingContext() {
  const isStandaloneContext = window?.location === window?.parent?.location;
  return {
    isRetailLaunchpad: !isStandaloneContext,
  };
}
